import { ReactNode } from 'react';
import { View } from 'react-native';
import { styles } from './ProgressLayout.styles';

export const ProgressLayout = ({ children }: { children: ReactNode }) => {
  return <View style={styles.container}>{children}</View>;
};
